module.exports = __webpack_public_path__ + "static/media/illustration-fix.9f243c21.svg";